import styled from 'styled-components/macro'

export const HeatMapWrapperDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
`
